// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilBlack":"#2c2e2f","h2":"style_h2__2r1Y-"};